<!-- ============================================================= -->
<!-- NEW DESIGN — small view (used in the /jobs listing)           -->
<!-- ============================================================= -->
<div class="gjc-card" *ngIf="view === 'small'"
     [class.gjc-card--active]="selectedItem == passValues?.jobId"
     [class.gjc-card--featured]="passValues?.isFeatured"
     [class.gjc-card--disabled]="!passValues?.availability">

  <ng-template #cardInner>
    <div class="gjc-top">
      <div class="gjc-head">
        <div class="gjc-title" [title]="passValues?.jobTitle">{{ passValues?.jobTitle || '-' }}</div>
        <div class="gjc-company" [title]="passValues?.jobPostedBehalfOf">{{ passValues?.jobPostedBehalfOf || '-' }}</div>
      </div>
      <div class="gjc-pills">
        <span class="gjc-status" [ngClass]="'gjc-status--' + getStatusClass(passValues?.status)">
          {{ passValues?.status || '-' }}
        </span>
        <span class="gjc-tag gjc-tag--urgent"
              *ngIf="getActiveUrgencyDays(passValues) as urgencyDays"
              [title]="'Urgent Hire — urgency ends in ' + urgencyDays + ' day' + (urgencyDays === 1 ? '' : 's')">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M13.5 0c.6 0 1.3 1.6 1.5 3 .3 1.8.1 3-1 4.3 1.5-.6 3-.5 4-.3 1.4.3 2.5 1.4 2.6 2.9.1 1.5-.8 2.7-2 3.1.8.7 1.4 1.7 1.4 3 0 2.8-3.1 5.2-7 5.2-3.5 0-7-2.2-7-5.7 0-1.8 1-3.5 2-4.7C7.8 9.6 7 8.4 7 6.7 7 4 9.7 1.8 13.5 0z"/>
          </svg>
          Urgent Hire
          <small class="gjc-tag-days">· {{ urgencyDays }}d</small>
        </span>
      </div>
    </div>

    <div class="gjc-meta">
      <div class="gjc-meta-row" [title]="passValues?.city + ', ' + passValues?.state">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
        </svg>
        <ng-container *ngIf="passValues?.city || passValues?.state || passValues?.country; else jobNoLoc">
          {{ passValues?.city }}<span *ngIf="passValues?.state">, {{ passValues?.state }}</span><span *ngIf="passValues?.country">, {{ passValues?.country }}</span>
        </ng-container>
        <ng-template #jobNoLoc>-</ng-template>
      </div>
      <div class="gjc-meta-row" [title]="passValues?.jobClassification">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
        {{ passValues?.jobClassification || '-' }}<span *ngIf="passValues?.jobClassification && passValues?.remoteWork"> · Remote</span>
      </div>
      <div class="gjc-meta-row">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
        {{ rateText || '-' }}
      </div>
    </div>
  </ng-template>

  <!-- Clickable region routes to the detail (or login, when used from a business context) -->
  <a *ngIf="!fromBusiness" [routerLink]="getRouteURL(passValues)" [queryParams]="currentQueryParams"
     class="gjc-cardlink" rel="noopener noreferrer"
     (click)="setJobData(passValues)" (click)="setMetaTags(passValues)">
    <ng-container *ngTemplateOutlet="cardInner"></ng-container>
  </a>
  <a *ngIf="fromBusiness" href="{{ getLoginParams(passValues) }}" target="_blank"
     class="gjc-cardlink" rel="noopener noreferrer"
     (click)="setJobData(passValues)" (click)="setMetaTags(passValues)">
    <ng-container *ngTemplateOutlet="cardInner"></ng-container>
  </a>

  <div class="gjc-footer">
    <span class="gjc-stat">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
      </svg>
      {{ passValues?.viewedByCount || 0 }} {{ (passValues?.viewedByCount || 0) > 1 ? 'views' : 'view' }}
    </span>
    <a class="gjc-apply" [class.gjc-apply--paused]="passValues?.status !== 'ACTIVE' || !passValues?.availability"
       href="{{ getLoginParams(passValues) }}" target="_blank" rel="noopener noreferrer">
      {{ (passValues?.status !== 'ACTIVE' || !passValues?.availability) ? 'Paused' : 'Apply' }}
    </a>
  </div>
</div>

<!-- ============================================================= -->
<!-- Big view (kept as-is; not used in the job-details listing)    -->
<!-- ============================================================= -->
<div *ngIf="view === 'big'" class="job-card-778" [ngClass]="{
    'disabled': !passValues?.availability,
    'featured-background': passValues?.isFeatured==true,
    'UpdatedJobHighLight': jobIdHighLight==passValues?.jobId,
    'highLightList': selectedItem == passValues?.jobId
  }">
    <div class="job-header-778">
        <div class="job-title-container-778">
            <h2 class="job-title-778" [title]="passValues?.jobTitle">
                {{passValues?.jobTitle}}
            </h2>
            <div *ngIf="getActiveUrgencyDays(passValues) as urgencyDays" style="margin-left: 8px;">
                <span class="urgent-hire-badge"><i class="fa fa-fire urgent-hire-icon"></i> Urgent Hire</span>
                <span class="urgent-hire-countdown" style="display: block; margin-top: 2px;">
                    Urgency ends in {{urgencyDays}} day{{urgencyDays === 1 ? '' : 's'}}
                </span>
            </div>
        </div>
        <p class="company-778" *ngIf="passValues?.showClientName" [title]="passValues?.clientName">
            <app-svg-templates class="svg-position" [svgType]="'BUILDING'"></app-svg-templates>
            {{passValues?.clientName | truncate:20}}
        </p>
    </div>

    <div class="job-details-778">
        <div class="detail-item-778" [title]="passValues?.city + ', ' + passValues?.state">
            <svg fill="rgb(0 0 0/0.6)" width="15px" height="15px" viewBox="0 0 32 32" version="1.1">
                <path
                    d="M16.114-0.011c-6.559 0-12.114 5.587-12.114 12.204 0 6.93 6.439 14.017 10.77 18.998 0.017 0.020 0.717 0.797 1.579 0.797h0.076c0.863 0 1.558-0.777 1.575-0.797 4.064-4.672 10-12.377 10-18.998 0-6.618-4.333-12.204-11.886-12.204zM16.515 29.849c-0.035 0.035-0.086 0.074-0.131 0.107-0.046-0.032-0.096-0.072-0.133-0.107l-0.523-0.602c-4.106-4.71-9.729-11.161-9.729-17.055 0-5.532 4.632-10.205 10.114-10.205 6.829 0 9.886 5.125 9.886 10.205 0 4.474-3.192 10.416-9.485 17.657zM16.035 6.044c-3.313 0-6 2.686-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zM16.035 16.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.207 0 4 1.794 4 4 0.001 2.206-1.747 4.044-3.954 4.044z">
                </path>
            </svg>
            <span>{{passValues?.city}}<span *ngIf="passValues?.state">,</span> {{passValues?.state}}</span>
        </div>

        <div class="detail-item-778" [title]="passValues?.jobClassification">
            <app-svg-templates class="svg-position" [svgType]="'SUITCASE_SMALL'"></app-svg-templates>
            <span>{{passValues?.jobClassification}}</span>
        </div>

        <div class="detail-item-778" *ngIf="passValues?.remoteWork">
            <app-svg-templates class="svg-position" [svgType]="'MAP'"></app-svg-templates>
            <span>Remote</span>
        </div>
    </div>

    <div class="tags-container-778">
        <ng-container *ngIf="passValues?.primarySkills">
            <ng-container *ngIf="isString(passValues.primarySkills); else arraySkills">
                <span class="tag-778"
                    *ngFor="let skill of passValues.primarySkills.split(',')?.slice(0, 3)">{{skill}}</span>
                <span class="tag-more-778" *ngIf="passValues.primarySkills.split(',')?.length > 3">
                    +{{passValues.primarySkills.split(',')?.length - 3}} more
                </span>
            </ng-container>
            <ng-template #arraySkills>
                <span class="tag-778" *ngFor="let skill of getSkillsArray().slice(0, 3)">{{skill}}</span>
                <span class="tag-more-778" *ngIf="getSkillsArray().length > 3">
                    +{{getSkillsArray().length - 3}} more
                </span>
            </ng-template>
        </ng-container>
    </div>

    <div class="job-footer-778">
        <span class="posted-778">Posted on {{passValues?.createdOn | date:"MM/dd/yyyy"}}</span>

        <div class="footer-actions-778">
            <a [routerLink]="getRouteURL(passValues)" [queryParams]="currentQueryParams"
                class="view-details-btn-778" (click)="setJobData(passValues)" (click)="setMetaTags(passValues)">
                View Details
            </a>
        </div>
    </div>
</div>
